import React from 'react';

const UnderConstruction = () => {
  const containerStyle = {
    margin: 0,
    padding: 0,
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#111',
    color: '#fff',
    fontFamily: 'Arial, sans-serif',
    fontSize: '2rem',
    textAlign: 'center',
    flexDirection: 'column'
  };

  return (
    <div style={containerStyle}>
     COMING SOON
    </div>
  );
};

export default UnderConstruction;
